function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
// Type validator

function Validate() {}
;
Validate.prototype = {
  Coords: function Coords(input) {
    if (input.constructor !== Array) {
      console.error("Coords must be an array");
      return;
    }
    if (input.length < 2) {
      console.error("Coords length must be at least 2");
      return;
    }
    var _iterator = _createForOfIteratorHelper(input),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var member = _step.value;
        if (member.constructor !== Number) {
          console.error("Coords values must be numbers");
          return;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    if (Math.abs(input[1]) > 90) {
      console.error("Latitude must be between -90 and 90");
      return;
    }
    return input;
  },
  Line: function Line(input) {
    var scope = this;
    if (input.constructor !== Array) {
      console.error("Line must be an array");
      return;
    }
    var _iterator2 = _createForOfIteratorHelper(input),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var coord = _step2.value;
        if (!scope.Coords(coord)) {
          console.error("Each coordinate in a line must be a valid Coords type");
          return;
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    return input;
  },
  Rotation: function Rotation(input) {
    if (input.constructor === Number) input = {
      z: input
    };else if (input.constructor === Object) {
      for (var _i = 0, _Object$keys = Object.keys(input); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];
        if (!['x', 'y', 'z'].includes(key)) {
          console.error('Rotation parameters must be x, y, or z');
          return;
        }
        if (input[key].constructor !== Number) {
          console.error('Individual rotation values must be numbers');
          return;
        }
      }
    } else {
      console.error('Rotation must be an object or a number');
      return;
    }
    return input;
  },
  Scale: function Scale(input) {
    if (input.constructor === Number) {
      input = {
        x: input,
        y: input,
        z: input
      };
    } else if (input.constructor === Object) {
      for (var _i2 = 0, _Object$keys2 = Object.keys(input); _i2 < _Object$keys2.length; _i2++) {
        var key = _Object$keys2[_i2];
        if (!['x', 'y', 'z'].includes(key)) {
          console.error('Scale parameters must be x, y, or z');
          return;
        }
        if (input[key].constructor !== Number) {
          console.error('Individual scale values must be numbers');
          return;
        }
      }
    } else {
      console.error('Scale must be an object or a number');
      return;
    }
    return input;
  }
};
module.exports = exports = Validate;